import makeRequest from 'api/makeRequest';
import environment from 'environment';

export const getAgentAssistResponse = async (data) => {
  const res = await makeRequest(`${environment.services.agentAssistMLUrl}`, {
    method: 'post',
    data,
  });

  return res;
};
